module.exports = __webpack_public_path__ + "static/media/search-icon.01609328.svg";